import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SafeSvgPipe} from './safe-svg.pipe';
import {CategoryVisualComponent} from './category-visual/category-visual.component';

@NgModule({
  declarations: [SafeSvgPipe, CategoryVisualComponent],
  imports: [CommonModule],
  exports: [SafeSvgPipe, CategoryVisualComponent],
})
export class SafeSvgModule {}
